import type { GraphQLFormattedError } from 'graphql'
import { isBillingPlanFeaturesEnumV2 } from 'routes/[businessId]/helpers/isBillingPlanFeaturesEnumV2/isBillingPlanFeaturesEnumV2'
import type { BillingPlanFeaturesEnumV2 } from 'gql/types'

/**
 * The billing feature the server refused the operation on, read off the first GraphQL error tagged
 * with one, or null when none of them is a feature gate. Drives the upsell prompt.
 *
 * Takes the errors rather than the enclosing error object so it stays off Apollo's disjoint error
 * classes — `GraphQLFormattedError` is the stable shape regardless of which class carried them.
 */
export const getFeatureGatingError = (
  graphQLErrors: readonly GraphQLFormattedError[],
): BillingPlanFeaturesEnumV2 | null => {
  const feature = graphQLErrors.find((gqlError) => gqlError.extensions?.feature)?.extensions?.feature

  return isBillingPlanFeaturesEnumV2(feature) ? feature : null
}
